import type { BatchSummary } from '@shared/models/BatchSummary';

/**
 * Etiqueta de lote utilizable en UI (excluye vacío y el literal típico "null").
 */
export function sanitizeBatchNumberForDisplay(raw: string | number | null | undefined): string | null {
  if (raw == null) return null;
  const t = String(raw).trim();
  if (t === '' || t.toLowerCase() === 'null') return null;
  return t;
}

/** True si hay algo que debe mostrar `LineBatchMeta` (coincide con su lógica de contenido visible). */
export function hasRenderableLineBatchMeta(args: {
  batch?: Pick<BatchSummary, 'batch_number' | 'expiry_date'> | null;
  batchId?: number | null;
  hideNumericIdFallback?: boolean;
}): boolean {
  const { batch, batchId, hideNumericIdFallback = false } = args;
  const fromName = batch?.batch_number != null ? sanitizeBatchNumberForDisplay(batch.batch_number) : null;
  const loteValue = fromName != null ? fromName : !hideNumericIdFallback && batchId != null ? `#${batchId}` : null;
  const hasExpiry = Boolean(batch?.expiry_date?.toString().trim?.());
  return !!(loteValue || hasExpiry);
}
